// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: var(--ion-color-primary);
  color: white;
  padding: 8px 12px;
  text-decoration: none;
  border-radius: 4px;
  z-index: 9999;
  font-size: 14px;
}
.skip-link:focus, .skip-link:focus-visible {
  top: 6px;
  outline: 2px solid white;
  outline-offset: 2px;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 20px 20px;
  background: white;
  margin: 0;
  overflow: hidden;
  position: relative;
}
.container:focus-within {
  outline: none;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--ion-color-primary);
  margin-bottom: 8px;
  margin-top: 0;
}

.info {
  font-family: AppFont, sans-serif;
  font-size: 17px;
  margin-top: 15px;
  line-height: 30px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--ion-color-secondary);
  margin-bottom: 35px;
}

.button-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.button {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--buttons-font-family, AppFont), sans-serif;
  position: relative;
  background: none;
  padding: 0;
  outline: none;
}
.button:focus, .button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
  z-index: 2;
  transform: scale(1.02);
}
.button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.button:active {
  transform: translateY(0);
  transition: transform 0.1s ease;
}
.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.button:disabled:focus, .button:disabled:focus-visible {
  outline-color: var(--ion-color-medium);
}
.button_main {
  background: var(--ion-color-primary);
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: white;
  font-weight: 600;
}
.button_main:focus, .button_main:focus-visible {
  outline: 3px solid white;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px var(--ion-color-primary-shade);
}
.button_main:hover:not(:disabled) {
  background: var(--ion-color-primary-shade);
  box-shadow: 0 6px 16px rgba(56, 128, 255, 0.3);
}
.button_main:active {
  background: var(--ion-color-primary-tint);
}
.button_close {
  background: var(--ion-color-tertiary);
  color: var(--ion-color-tertiary-contrast);
  min-height: 54px;
  text-align: center;
  font-size: var(--buttons-font-size, 16px);
  margin: 0;
  text-transform: var(--buttons-text-transform, none);
  color: var(--buttons-text-color, var(--ion-color-tertiary-contrast));
}
.button_close:focus, .button_close:focus-visible {
  outline: 3px solid var(--ion-color-tertiary-shade);
  outline-offset: 2px;
}
.button_close:hover:not(:disabled) {
  background: var(--ion-color-tertiary-shade);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.button_close:active {
  background: var(--ion-color-tertiary-tint);
}

@media (prefers-contrast: high) {
  .button {
    border: 2px solid transparent;
  }
  .button:focus, .button:focus-visible {
    outline-width: 4px;
    border-color: currentColor;
  }
  .button_main {
    border-color: white;
  }
  .button_main:focus, .button_main:focus-visible {
    border-color: yellow;
    outline-color: yellow;
  }
  .button_close {
    border-color: var(--ion-color-tertiary-contrast);
  }
  .title {
    font-weight: 700;
  }
}
@media (prefers-reduced-motion: reduce) {
  .button {
    transition: none;
  }
  .button:hover:not(:disabled), .button:focus, .button:focus-visible {
    transform: none;
  }
  .button:active {
    transition: none;
  }
  .skip-link:focus, .skip-link:focus-visible {
    transition: none;
  }
}
@media (max-width: 768px) {
  .button {
    min-height: 48px;
  }
  .button:hover {
    transform: none;
  }
  .button::before {
    content: "";
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    background: transparent;
  }
}
[dir=rtl] .skip-link {
  left: auto;
  right: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/change-venue-popover/change-venue-popover.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AADF;AAGE;EAEE,QAAA;EACA,wBAAA;EACA,mBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAHF;AAME;EACE,aAAA;AAJJ;;AAQA;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;AALF;;AAQA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;AALF;;AASA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AANF;;AASA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,4DAAA;EACA,kBAAA;EAGA,gBAAA;EACA,UAAA;EACA,aAAA;AARF;AAWE;EAEE,2CAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;AAVJ;AAcE;EACE,2BAAA;EACA,0CAAA;AAZJ;AAgBE;EACE,wBAAA;EACA,+BAAA;AAdJ;AAkBE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAhBJ;AAkBI;EAEE,sCAAA;AAjBN;AAqBE;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAnBJ;AAsBI;EAEE,wBAAA;EACA,mBAAA;EACA,oDAAA;AArBN;AAwBI;EACE,0CAAA;EACA,8CAAA;AAtBN;AAyBI;EACE,yCAAA;AAvBN;AA2BE;EACE,qCAAA;EACA,yCAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,SAAA;EACA,mDAAA;EACA,oEAAA;AAzBJ;AA2BI;EAEE,kDAAA;EACA,mBAAA;AA1BN;AA6BI;EACE,2CAAA;EACA,yCAAA;AA3BN;AA8BI;EACE,0CAAA;AA5BN;;AAkCA;EACE;IACE,6BAAA;EA/BF;EAiCE;IAEE,kBAAA;IACA,0BAAA;EAhCJ;EAmCE;IACE,mBAAA;EAjCJ;EAmCI;IAEE,oBAAA;IACA,qBAAA;EAlCN;EAsCE;IACE,gDAAA;EApCJ;EAwCA;IACE,gBAAA;EAtCF;AACF;AA0CA;EACE;IACE,gBAAA;EAxCF;EA0CE;IAGE,eAAA;EA1CJ;EA6CE;IACE,gBAAA;EA3CJ;EAgDE;IAEE,gBAAA;EA/CJ;AACF;AAoDA;EACE;IACE,gBAAA;EAlDF;EAoDE;IACE,eAAA;EAlDJ;EAsDE;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,uBAAA;EApDJ;AACF;AA0DE;EACE,UAAA;EACA,UAAA;AAxDJ","sourcesContent":["// Screen reader only utility\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Skip link for keyboard navigation\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 6px;\n  background: var(--ion-color-primary);\n  color: white;\n  padding: 8px 12px;\n  text-decoration: none;\n  border-radius: 4px;\n  z-index: 9999;\n  font-size: 14px;\n  \n  &:focus,\n  &:focus-visible {\n    top: 6px;\n    outline: 2px solid white;\n    outline-offset: 2px;\n  }\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 20px 20px;\n  background: white;\n  margin: 0;\n  overflow: hidden;\n  position: relative;\n  \n  // Focus trap styling\n  &:focus-within {\n    outline: none;\n  }\n}\n\n.title {\n  font-family: AppFontBold, sans-serif;\n  font-size: 24px;\n  line-height: 30px;\n  letter-spacing: 0.06em;\n  text-align: center;\n  color: var(--ion-color-primary);\n  margin-bottom: 8px;\n  margin-top: 0;\n}\n\n.info {\n  font-family: AppFont, sans-serif;\n  font-size: 17px;\n  margin-top: 15px;\n  line-height: 30px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: var(--ion-color-secondary);\n  margin-bottom: 35px;\n}\n\n// Button group for better semantic structure\n.button-group {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.button {\n  height: 60px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 16px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: var(--buttons-font-family, AppFont), sans-serif;\n  position: relative;\n  \n  // Remove default button styles\n  background: none;\n  padding: 0;\n  outline: none;\n  \n  // Enhanced focus styles for keyboard navigation\n  &:focus,\n  &:focus-visible {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n    z-index: 2;\n    transform: scale(1.02);\n  }\n  \n  // Hover effects\n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n  \n  // Active state\n  &:active {\n    transform: translateY(0);\n    transition: transform 0.1s ease;\n  }\n  \n  // Disabled state\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n    \n    &:focus,\n    &:focus-visible {\n      outline-color: var(--ion-color-medium);\n    }\n  }\n\n  &_main {\n    background: var(--ion-color-primary);\n    font-size: 20px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: white;\n    font-weight: 600;\n    \n    // Enhanced focus for primary button\n    &:focus,\n    &:focus-visible {\n      outline: 3px solid white;\n      outline-offset: 2px;\n      box-shadow: 0 0 0 6px var(--ion-color-primary-shade);\n    }\n    \n    &:hover:not(:disabled) {\n      background: var(--ion-color-primary-shade);\n      box-shadow: 0 6px 16px rgba(56, 128, 255, 0.3);\n    }\n    \n    &:active {\n      background: var(--ion-color-primary-tint);\n    }\n  }\n\n  &_close {\n    background: var(--ion-color-tertiary);\n    color: var(--ion-color-tertiary-contrast);\n    min-height: 54px;\n    text-align: center;\n    font-size: var(--buttons-font-size, 16px);\n    margin: 0;\n    text-transform: var(--buttons-text-transform, none);\n    color: var(--buttons-text-color, var(--ion-color-tertiary-contrast));\n    \n    &:focus,\n    &:focus-visible {\n      outline: 3px solid var(--ion-color-tertiary-shade);\n      outline-offset: 2px;\n    }\n    \n    &:hover:not(:disabled) {\n      background: var(--ion-color-tertiary-shade);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n    \n    &:active {\n      background: var(--ion-color-tertiary-tint);\n    }\n  }\n}\n\n// High contrast mode support\n@media (prefers-contrast: high) {\n  .button {\n    border: 2px solid transparent;\n    \n    &:focus,\n    &:focus-visible {\n      outline-width: 4px;\n      border-color: currentColor;\n    }\n    \n    &_main {\n      border-color: white;\n      \n      &:focus,\n      &:focus-visible {\n        border-color: yellow;\n        outline-color: yellow;\n      }\n    }\n    \n    &_close {\n      border-color: var(--ion-color-tertiary-contrast);\n    }\n  }\n  \n  .title {\n    font-weight: 700;\n  }\n}\n\n// Reduced motion support\n@media (prefers-reduced-motion: reduce) {\n  .button {\n    transition: none;\n    \n    &:hover:not(:disabled),\n    &:focus,\n    &:focus-visible {\n      transform: none;\n    }\n    \n    &:active {\n      transition: none;\n    }\n  }\n  \n  .skip-link {\n    &:focus,\n    &:focus-visible {\n      transition: none;\n    }\n  }\n}\n\n// Mobile touch improvements\n@media (max-width: 768px) {\n  .button {\n    min-height: 48px; // Minimum touch target size\n    \n    &:hover {\n      transform: none; // Disable hover effects on touch devices\n    }\n    \n    // Larger touch targets\n    &::before {\n      content: '';\n      position: absolute;\n      top: -4px;\n      left: -4px;\n      right: -4px;\n      bottom: -4px;\n      background: transparent;\n    }\n  }\n}\n\n// RTL support\n[dir=\"rtl\"] {\n  .skip-link {\n    left: auto;\n    right: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
